import { ComponentFactoryResolver, ComponentRef, Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2, Self, ViewContainerRef } from '@angular/core';
import { ErrorFormFieldComponent } from '../components/error-form-field/error-form-field.component';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[splitValidadorCampoFormulario]',

})
export class ValidatorFormFieldDirective implements OnInit, OnDestroy {
  @Input() enableMsgErro = false;
  @Input() msgErro: any
  @Input() labelWidth!: string;

  componentRef!: ComponentRef<ErrorFormFieldComponent>;
  private componenteCriado = false;

  sub: Subscription | undefined;

  constructor(
    @Self() private ngControl: NgControl,
    private renderer: Renderer2,
    private el: ElementRef,
    private resolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef
  ) {

  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  ngOnInit() {
    this.sub = this.ngControl.statusChanges?.subscribe(() => {
      this.validarCampo();
      if(this.enableMsgErro) {
        this.escolherMsgErro();
      }
    });

  }


  private validarCampo() {

    if (this.campoInvalido()) {
      this.criarComponente();
      return;
    }
    this.destruirComponente();
  }

  private criarComponente() {
    if (!this.componenteCriado) {
      //this.renderer.removeClass(this.el.nativeElement, 'is-valid');
      this.renderer.addClass(this.el.nativeElement, 'is-invalid');


      this.renderer.addClass(this.el.nativeElement, 'ng-select-error');
      this.renderer.removeClass(this.el.nativeElement, 'ng-select-success');
      const componentFactory = this.resolver
        .resolveComponentFactory(ErrorFormFieldComponent);
      this.componentRef = this.viewContainerRef.createComponent(componentFactory);

      this.componenteCriado = true;
    }
  }

  private destruirComponente() {
    this.renderer.removeClass(this.el.nativeElement, 'is-invalid');
    //this.renderer.addClass(this.el.nativeElement, 'is-valid');

    this.renderer.addClass(this.el.nativeElement, 'ng-select-success');
    this.renderer.removeClass(this.el.nativeElement, 'ng-select-error');
    if (this.componenteCriado) {
      this.componentRef.destroy();
      this.componenteCriado = false;
    }
  }

  private escolherMsgErro() {


    const erros:any = this.ngControl.control?.errors;
    if (this.componentRef && erros) {

      if(erros.incorrect && erros.incorrect != "") {
        this.componentRef.instance.errorMsg = erros.incorrect;
      } else if (erros.required) {
        this.componentRef.instance.errorMsg = "Campo Obrigatório";
      } else if (erros.minlength) {
        this.componentRef.instance.errorMsg = `Tamanho mínimo de ${erros.minlength.requiredLength}`;
      } else if (erros.maxlength) {
        this.componentRef.instance.errorMsg = `Tamanho máximo de ${erros.maxlength.requiredLength}`;
      } else if (erros.min) {
        this.componentRef.instance.errorMsg = `Valor mínimo é ${erros.min.min}`;
      } else if (erros.max) {
        this.componentRef.instance.errorMsg = `Valor máximo é ${erros.max.max}`;
      } else if (erros.email) {
        this.componentRef.instance.errorMsg = `Email inválido`;
      } else if (erros.inputMask) {
        this.componentRef.instance.errorMsg = `Formato não inválido .`;
      } else if (erros.ngSelect) {
        this.componentRef.instance.errorMsg = this.msgErro;
      } else {
        setTimeout(() => {
          this.componentRef.instance.errorMsg = this.msgErro;
        }, 1);
      }
    }
  }

  private campoInvalido(): boolean | null {
    return !this.ngControl.pending &&
      !this.ngControl.valid &&
      (this.ngControl.touched || this.ngControl.dirty);
  }

  onBlur($event: any) {
    this.ngControl.control?.updateValueAndValidity({onlySelf: true});
  }

  @HostListener('change',['$event'])
  onSelect(event:any) {
    this.ngControl.control?.updateValueAndValidity({onlySelf: true});
  }
}
